import FamilyPK from '~/pages/FamilyPK/reducers'
import GreedyRecharge from '~/pages/GreedyRecharge/reducers'
import GreedyRechargeNew from '~/pages/GreedyRechargeNew/reducers'
import AboutToPlay from '~/pages/AboutToPlay/reducers'
import ActivityCenter from '~/pages/ActivityCenter/reducers'
import AggregateBanner from '~/pages/AggregateBanner/reducers'
import AnchorTask from '~/pages/AnchorTask/reducers'
import AnnualIndividualPK from '~/pages/AnnualIndividualPK/reducers'
import AnnualSum2022 from '~/pages/AnnualSum2022/reducers'
import BigRRechargeTask from '~/pages/BigRRechargeTask/reducers'
import CastleCrush from '~/pages/CastleCrush/reducers'
import CoinagencyRank from '~/pages/CoinagencyRank/reducers'
import Corban from '~/pages/Corban/reducers'
import ElephantModal from '~/pages/ElephantModal/reducers'
import FamilySpeed from '~/pages/FamilySpeed/reducers'
import FightMonster from '~/pages/FightMonster/reducers'
import GoldLudoCoolBoot from '~/pages/GoldLudoCoolBoot/reducers'
import GoodsSale from '~/pages/GoodsSale/reducers'
import HitAnimalsModal from '~/pages/HitAnimalsModal/reducers'
import HiyaFarm2022 from '~/pages/HiyaFarm2022/reducers'
import HiyaLuckyDraw from '~/pages/HiyaLuckyDraw/reducer'
import IdsIndependDayModal from '~/pages/IdsIndependDayModal/reducers'
import ZaiShengJie2023Modal from '~/pages/ZaiShengJie2023Modal/reducers'
import Lohri from '~/pages/Lohri/reducers'
import LuckRank from '~/pages/LuckRank/reducers'
import LuckyGuy from '~/pages/LuckyGuy/reducers'
import LudoFamilyCreate from '~/pages/LudoFamilyCreate/reducers'
import BingoColdBoot from '~/pages/LudoGamesBoot/BingoColdBoot/reducers'
import BingoColdBootV2 from '~/pages/LudoGamesBoot/BingoColdBootV2/reducers'
import DiminoSkin from '~/pages/LudoGamesBoot/DiminoSkin/reducers'
import Uno from '~/pages/LudoGamesBoot/Uno/reducers'
import LudoQualifying from '~/pages/LudoQualifying/reducers'
import LudoRank from '~/pages/LudoRank/reducers'
import LudoSkin from '~/pages/LudoSkin/reducers'
import LudoTurntable from '~/pages/LudoTurntable/reducers'
import LudoTurntableSkin from '~/pages/LudoTurntable/Skin/reducers'
import LunarNewYear2022 from '~/pages/LunarNewYear2022/reducers'
import LunarNewYear2023 from '~/pages/LunarNewYear2023/reducers'
import LuxuryCarAuction from '~/pages/LuxuryCarAuction/reducers'
import LuxuryCarFair from '~/pages/LuxuryCarFair/reducers'
import NewYear2021 from '~/pages/NewYear2021/reducers'
import PartnerPlan from '~/pages/PartnerPlan/reducers'
import RaiseAFlag from '~/pages/RaiseAFlag/reducers'
import recharge from '~/pages/recharge/reducers'
import ResetPassWord from '~/pages/ResetPassWord/reducers'
import RightDiscountSale from '~/pages/RightDiscountSale/reducers'
import RoomBonus from '~/pages/RoomBonus/reducers'
import RoomPartyGift from '~/pages/RoomPartyGift/reducers'
import StarHunter from '~/pages/StarHunter/reducers'
import StarWars from '~/pages/StarWars/reducers'
import TopRoom from '~/pages/TopRoom/reducers'
import CrazyRecharge from '~/pages/ToyBricks/CustomComponents/CrazyRecharge/reducers'
import ShowYourLove from '~/pages/ToyBricks/CustomComponents/ShowYourLove/reducers'
import Monopoly from '~/pages/ToyBricks/CustomComponents/MonoPoly/reducers'
import GameCenter from '~/pages/ToyBricks/CustomComponents/GameCenter/reducers'
import YearPinXuan from '~/pages/ToyBricks/CustomComponents/YearPinXuan/reducers'
import BigAward from '~/pages/ToyBricks/CustomComponents/BigAward/reducers'
import RamadanSheep from '~/pages/RamadanSheep/reducers'
import ToyBricks from '~/pages/ToyBricks/reducers'
import unionBattleA from '~/pages/UnionBattleA/reducers'
import unionBattleAAr from '~/pages/UnionBattleAAr/reducers'
import Valentine2022 from '~/pages/Valentine2022/reducers'
import WeekGiftStar from '~/pages/WeekGiftStar/reducers'
import WelcomeTasks from '~/pages/WelcomeTasks/reducers'
import WorldCup2022 from '~/pages/WorldCup2022/reducers'
import Xmas2021 from '~/pages/Xmas2021/reducers'
import RamadanActive from '~/pages/RamadanActive/reducers'
import TurnPlate from '~/pages/ToyBricks/components/TurnPlateV1/reducers'
import Ramadan2024 from '~/pages/Ramadan2024/reducers'
import crossroompkundertask from './crossroompkundertask'
import GiftsBlindBox from './GiftsBlindBox'
import IndianIPL from './IndianIPL'
import rankTask from './rankTask'
import TerritoryBattle from './TerritoryBattle'
import WildBlindBox from './WildBlindBox'
import CastleActive from '../pages/ToyBricks/CustomComponents/CastleActive/reducers'
import chat from './chat'
import FastingDay from '../pages/FastingDay/reducers'
import YearVote2023 from '../pages/ToyBricks/CustomComponents/YearVote2023/reducers'
import TrMusic from '../pages/ToyBricks/CustomComponents/TrMusic/reducers'
import YearVoteSongkran from '../pages/ToyBricks/CustomComponents/YearVoteSongkran/reducers'
import YearVoteSongkranV1 from '../pages/ToyBricks/CustomComponents/YearVoteSongkranV1/reducers'
import YearVoteSongkranV2 from '../pages/ToyBricks/CustomComponents/YearVoteSongkranV2/reducers'
import YearVoteSongkranV3 from '../pages/ToyBricks/CustomComponents/YearVoteSongkranV3/reducers'
import NewUnionAnchor from '../pages/NewUnionAnchor/reducers'
import NewYearUnionGame from '../pages/NewYearUnionGame/reducers'
import NewYearUnionGame2026 from '../pages/NewYearUnionGame2026/reducers'
import XWFestival from '../pages/ToyBricks/CustomComponents/MaleKingDay/reducers'
import RamadanSheep2025 from '~/pages/RamadanSheep2025/reducers'
import UserVerification from './UserVerification'
import HWFestival from '../pages/ToyBricks/CustomComponents/HolyWeek/reducers'
import rechargeGroup from '../pages/ToyBricks/CustomComponents/RechargeGroup/reducers'
import StarHunterV2 from '~/pages/StarHunterV2/reducers'
import SuperLuckyKing from '~/pages/ToyBricks/CustomComponents/SuperLuckyKing/reducers'
import CricketWars from '~/pages/ToyBricks/CustomComponents/CricketWars/reducers'
import ATM from '../pages/ATM/reducers'
import PkTeam from '../pages/ToyBricks/CustomComponents/PkTeam/reducers'
import YearVote2025 from '../pages/ToyBricks/CustomComponents/YearVote2025/reducers'
import AnnualGame2025 from '../pages/ToyBricks/CustomComponents/AnnualGame2025/reducers'
import AnnualHomepage2025 from '../pages/ToyBricks/CustomComponents/AnnualHomepage2025/reducers'
import PaidActive2025 from '../pages/ToyBricks/CustomComponents/PaidActive2025/reducers'
import AnnualRecharge2025 from '../pages/ToyBricks/CustomComponents/AnnualRecharge2025/reducers'
import NewHouseLuckyStar from '../pages/ToyBricks/CustomComponents/NewHouseLuckyStar/reducers'
import YearInfluence2025 from '../pages/ToyBricks/CustomComponents/YearInfluence2025/reducers'
import Valentine2026 from '../pages/ToyBricks/CustomComponents/Valentine2026/reducers'
import RamadanHomepage2026 from '../pages/ToyBricks/CustomComponents/RamadanHomepage2026/reducers'
import ActiveCultivate2026 from '../pages/ToyBricks/CustomComponents/ActiveCultivate2026/reducers'
import UserPeak2026 from '../pages/ToyBricks/CustomComponents/UserPeak2026/reducers'
import CricketWarsV2 from '~/pages/ToyBricks/CustomComponents/CricketWarsV2/reducers'
import Puzzle24 from '../pages/ToyBricks/CustomComponents/Puzzle24/reducers'
import CaravanGuards from '../pages/ToyBricks/CustomComponents/CaravanGuards/reducers'
import BigRTeam from '../pages/ToyBricks/CustomComponents/BigRTeam/reducers'
import NewHouseLuckyStarTr2026 from '../pages/ToyBricks/CustomComponents/NewHouseLuckyStarTr2026/reducers'
import CricketWarsV3 from '~/pages/ToyBricks/CustomComponents/CricketWarsV3/reducers'
import LuckFomo from '../pages/LuckFomo/reducers'
import SpinNewUser from '../pages/ToyBricks/CustomComponents/SpinNewUser/reducers'
import CPRelation from '~/pages/CPRelation/reducers'
import WorldCup from '../pages/ToyBricks/CustomComponents/WorldCup/reducers'
import NewYearUnionGameV2 from '../pages/NewYearUnionGameV2/reducers'
import AnchorTeamPk from '~/pages/ToyBricks/CustomComponents/AnchorTeamPk/reducers'
import CricketWarsV4 from '~/pages/ToyBricks/CustomComponents/CricketWarsV4/reducers'
import MidYearAggregation from '../pages/ToyBricks/CustomComponents/MidYearAggregation/reducers'
import WordCupCarnival from '../pages/ToyBricks/CustomComponents/WordCupCarnival/reducers'
import BigRVote2026 from '../pages/ToyBricks/CustomComponents/BigRVote2026/reducers'

export default {
  FastingDay,
  GreedyRecharge,
  GreedyRechargeNew,
  ...chat,
  RightDiscountSale,
  ToyBricks,
  RaiseAFlag,
  FamilyPK,
  LuxuryCarFair,
  GiftsBlindBox,
  FamilySpeed,
  IndianIPL,
  rankTask,
  TerritoryBattle,
  WildBlindBox,
  StarWars,
  crossroompkundertask,
  AnnualIndividualPK,
  unionBattleA,
  unionBattleAAr,
  Xmas2021,
  NewYear2021,
  LuckRank,
  Lohri,
  recharge,
  WeekGiftStar,
  CoinagencyRank,
  Valentine2022,
  LuxuryCarAuction,
  PartnerPlan,
  FightMonster,
  LudoSkin,
  AnchorTask,
  WelcomeTasks,
  HiyaFarm2022,
  AggregateBanner,
  HiyaLuckyDraw,
  AboutToPlay,
  BigRRechargeTask,
  CastleCrush,
  LudoQualifying,
  LudoRank,
  LudoFamilyCreate,
  RoomBonus,
  DiminoSkin,
  GoldLudoCoolBoot,
  Corban,
  LudoTurntable,
  LudoTurntableSkin,
  HitAnimalsModal,
  ShowYourLove,
  IdsIndependDayModal,
  ZaiShengJie2023Modal,
  TopRoom,
  BingoColdBoot,
  BingoColdBootV2,
  GoodsSale,
  RoomPartyGift,
  ResetPassWord,
  ElephantModal,
  Uno,
  CrazyRecharge,
  LuckyGuy,
  WorldCup2022,
  AnnualSum2022,
  ActivityCenter,
  LunarNewYear2022,
  LunarNewYear2023,
  RamadanActive,
  StarHunter,
  Monopoly,
  GameCenter,
  YearPinXuan,
  CastleActive,
  BigAward,
  YearVote2023,
  TurnPlate,
  TrMusic,
  Ramadan2024,
  RamadanSheep,
  YearVoteSongkran,
  YearVoteSongkranV1,
  YearVoteSongkranV2,
  YearVoteSongkranV3,
  NewUnionAnchor,
  NewYearUnionGame,
  NewYearUnionGame2026,
  XWFestival,
  RamadanSheep2025,
  UserVerification,
  HWFestival,
  rechargeGroup,
  StarHunterV2,
  SuperLuckyKing,
  CricketWars,
  ATM,
  PkTeam,
  YearVote2025,
  AnnualGame2025,
  AnnualHomepage2025,
  PaidActive2025,
  AnnualRecharge2025,
  NewHouseLuckyStar,
  YearInfluence2025,
  Valentine2026,
  RamadanHomepage2026,
  ActiveCultivate2026,
  UserPeak2026,
  CricketWarsV2,
  Puzzle24,
  CaravanGuards,
  BigRTeam,
  NewHouseLuckyStarTr2026,
  CricketWarsV3,
  LuckFomo,
  SpinNewUser,
  CPRelation,
  WorldCup,
  NewYearUnionGameV2,
  AnchorTeamPk,
  CricketWarsV4,
  MidYearAggregation,
  WordCupCarnival,
  BigRVote2026,
}
